import React from "react";
import { FaTaxi, FaUserTie, FaClock } from "react-icons/fa";
import { useGetRideShareDashboardSummaryQuery } from "../../store/api/rideshare/rideShareDashboardSlice";
import SkeletonLoading from "../../component/SkeletonLoading";

const StatCard = ({ icon, label, value, bg }) => (
  <li className="col-12 col-sm-4">
    <div className="inner" style={{ background: bg || "#F8F9FB" }}>
      <div className="hd d-flex align-items-center mb-3">
        <span>{icon}</span>
        <span className="ms-2">{label}</span>
      </div>
      <div className="price">
        <span className="d-block mb-1">{value ?? 0}</span>
      </div>
    </div>
  </li>
);

const RideShareDashboard = () => {
  const { data, isLoading, isError } = useGetRideShareDashboardSummaryQuery();

  const summary = data?.data || {};

  if (isLoading) {
    return (
      <div className="table m-0">
        <table>
          <tbody>
            <SkeletonLoading MainLength={3} length={3} />
          </tbody>
        </table>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center">
        <FaTaxi size={48} color="#f0b342" className="mb-3" />
        <h5 className="fw-bold mb-2">Taxi / Rideshare Dashboard</h5>
        <p className="text-danger">Unable to connect to Rideshare backend.</p>
      </div>
    );
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="dbSubHd">{summary.variant || "Rideshare"} Overview</div>
        {summary.identity?.taxiRole && (
          <span className="badge" style={{ background: "#f0b342", color: "#fff", fontSize: "13px", padding: "6px 14px", borderRadius: "20px" }}>
            {summary.identity.taxiRole}
          </span>
        )}
      </div>

      <ul className="dbTop p-0 d-flex flex-wrap">
        <StatCard
          icon={<FaTaxi className="icon" />}
          label="Active Trips"
          value={summary.activeTrips}
          bg="#FBF7F3"
        />
        <StatCard
          icon={<FaUserTie className="icon" />}
          label="Idle Drivers"
          value={summary.idleDrivers}
          bg="#E9FDF0"
        />
        <StatCard
          icon={<FaClock className="icon" />}
          label="Pending"
          value={summary.pending}
          bg="#F8F9FB"
        />
      </ul>
    </>
  );
};

export default RideShareDashboard;
